import { ILookup } from "../data/Ilookup";
import { LookupItem } from "./lookup-item";

export class InvestmentYear {
  turnover: LookupItem | null = null;
  ownershipInterest: string = '';
  netAssets: LookupItem | null = null;
  yearEnd: string = '';
}
  